import React from 'react';
import { Box, useTheme } from '@mui/material';

interface Props {
  html: string;
}
const Markdown = ({ html }: Props) => {
  const { shape, palette, spacing, typography } = useTheme();

  return (
    <Box
      dangerouslySetInnerHTML={{ __html: html }}
      sx={{
        marginTop: spacing(6),
        lineHeight: '22pt',
        color: palette.grey['800'],
        fontSize: '1rem',
        '& h2, & h3, & h4, & h5': {
          fontFamily: 'Noto Sans',
        },
        '& h2': {
          margin: `${spacing(6)} 0 ${spacing(2)}`,
          fontSize: '1.8rem',
        },
        '& h3': {
          margin: `${spacing(4)} 0 ${spacing(2)}`,
          fontSize: '1.4rem',
        },
        '& h4': {
          margin: `${spacing(3)} 0 ${spacing(2)}`,
          fontSize: '1.2rem',
        },
        '& h5': {
          margin: `${spacing(3)} 0 ${spacing(2)}`,
          fontSize: '1rem',
        },
        '& p': {
          wordBreak: 'break-all',
        },
        '& a': {
          color: palette.text.primary,
          '&:hover': {
            textDecoration: 'underline',
          },
        },
        '& small': {
          fontSize: typography.caption.fontSize,
        },
        '& hr': {
          borderTop: `1px dashed ${palette.grey['400']}`,
          display: 'block',
          margin: `${spacing(3)} 0`,
        },
        '& blockquote': {
          backgroundColor: palette.grey['200'],
          borderLeft: `4px solid ${palette.grey['300']}`,
          padding: `${spacing(2)} ${spacing(2.5)}`,
          margin: `${spacing(3)} 0`,
          textAlign: 'left',
        },
        '& span.gatsby-resp-image-wrapper': {
          borderRadius: shape.borderRadius,
          overflow: 'hidden',
          margin: `${spacing(5)} 0 ${spacing(5)}`,
          '& + small': {
            display: 'block',
            color: palette.grey['700'],
            marginTop: spacing(-3),
            marginBottom: spacing(5),
          },
        },
        '& table': {
          width: '100%',
          borderCollapse: 'collapse',
          margin: `${spacing(5)} 0 ${spacing(5)}`,
          '& thead': {
            backgroundColor: palette.grey['200'],
          },
          '& thead th': {
            borderRight: `1px solid ${palette.common.white}`,
          },
          '& tr': {
            borderBottom: `1px solid ${palette.grey['200']}`,
          },
          '& td, & th': {
            fontSize: '0.9rem',
            padding: `${spacing(1)} ${spacing(1.5)}`,
            textAlign: 'left',
            border: 'none',
            wordBreak: 'break-all',
            '&[align="center"]': {
              textAlign: 'center',
            },
          },
        },
        '& :not(pre) > code[class*="language-"]': {
          backgroundColor: `rgba(27, 31, 35, 0.05)`,
          color: '#005A8D',
          padding: `${spacing(0.4)} ${spacing(0.8)}`,
          borderRadius: '4px',
          whiteSpace: 'nowrap',
        },
        '& span.katex-display': {
          margin: `${spacing(4)} 0`,
        },
      }}
    />
  );
};

export default Markdown;
